// Centralized configuration - change links here and update everywhere
export const socialLinks = {
  facebook: "https://www.facebook.com/share/1GuPWm5WMT",
  line: "https://line.me/ti/p/hJdG41iKRb",
  instagram: "https://www.instagram.com/ploy.tip",
  tiktok: "https://www.tiktok.com/@ploy.tip"
};

export const footerLinks = [
  { text: "จองคิว", href: "index.html#contact" },
  { text: "รีวิว", href: "reviews.html" },
  { text: "ขั้นตอนในการดู", href: "steps.html" },
  { text: "แปลงเวลา", href: "time.html" }
];

// Generate and insert footer content
export function applyFooter() {
  const footer = document.querySelector('footer.footer');
  if (!footer) return;

  footer.innerHTML = `
    <div class="container">
      <a rel="noreferrer" href="#top" class="back-to-top">
        <i class="fa fa-angle-up fa-2x" aria-hidden="true"></i>
      </a>
      <div class="social-links">
        <a rel="noreferrer" href="${socialLinks.line}" target="_blank">
          <i class="fab fa-line"></i>
        </a>
        <a rel="noreferrer" href="${socialLinks.facebook}" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
        <a rel="noreferrer" href="${socialLinks.instagram}" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
        <a rel="noreferrer" href="${socialLinks.tiktok}" target="_blank">
          <i class="fab fa-tiktok"></i>
        </a>
      </div>

      <div class="footer-links">
        ${footerLinks.map(link => `
          <div class="footer__text" style="margin: 5px 0">
            <a href="${link.href}">${link.text}</a>
          </div>
        `).join('')}
      </div>

      <hr />

      <p class="footer__text">
        © 2021 - Template developed by
        <a rel="noreferrer" href="https://github.com/cobiwave" target="_blank">
          Jacobo Martínez
        </a>
      </p>
    </div>
  `;
}
